import React, { useState } from 'react';
import PlanChoosePopup from './PlanChoosePopup';
import Config from '../../../core/config';
import { makeRequestWithErrorMessage } from '../../../core/services/v1/request';
import { useContextData } from '../../../core/context';
import { toast } from '../../../core/lib/toastAlert';
const StakeBox = () => {
    const { earnBalance, setUserProfile, planAmount1, setPlanAmount1, referralId, setReferralId, myProfile } = useContextData();
    const [modalShow, setModalShow] = useState(false);
    const [loading, setLoading] = useState(false)
    const [plan, setPlan] = useState("")
    const submitStakeTrade = async () => {
        setLoading(() => true)

        // const params = {
        //     url: `${Config.V1_API_URL}stake-trade/verify-stake`,
        //     method: 'GET',
        // }
        // const res = await makeRequestWithErrorMessage(params)
        // if (res.status) {
        if (earnBalance?.available < Number(planAmount1)) {
            setLoading(() => false);
            return toast({ type: 'error', message: 'Insufficient Balance' })
        }

        const data = {
            name: plan,
            amount: planAmount1,
            referralId: referralId
        }
        const params = {
            url: `${Config.V1_API_URL}stake-trade/create-stake`,
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'Application/json',
            },
        }
        const res = await makeRequestWithErrorMessage(params)
        if (res.status) {
            setUserProfile();
            setLoading(() => false);
            toast({ type: 'success', message: res.message })
            setModalShow(false)
            setPlanAmount1(() => null)
            setReferralId(() => null)
        }
        else {
            setLoading(() => false);
            toast({ type: 'error', message: res.message })
        }
        setLoading(() => false);
        // }
        // else {
        //     setLoading(() => false)
        //     toast({ type: 'error', message: res.message })
        // }

        setLoading(() => false);
    }
    return (
        <div>
            <div className='w-100 d-flex justify-content-evenly align-items-start flex-wrap flex-column flex-lg-row' style={{ gap: '30px 0px' }}>
                <div className='width-stake-wrap'>
                    <div className='stake-box position-relative'>
                        <div className='plan-header-1'>
                            <h4 className='text-uppercase' style={{
                                fontSize: '16px',
                                color: '#FFF',
                                fontFamily: '"Lexend", sans-serif',
                                fontStyle: 'normal',
                                fontWeight: 700,
                                lineHeight: 'normal',
                            }}>usdt eARN pLAN 1</h4>
                        </div>

                        <div className='pt-0 pb-0 mt-2 mb-0'>
                            <img src='/assets/investment.png' alt='investment' className='img-fluid' />
                        </div>

                        <div className='px-3'>
                            {/* <div className='d-flex justify-content-start align-items-center pb-3' style={{ gap: '7px' }}>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#007F60" stroke="#007F60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16.125 9.75L10.6219 15L7.875 12.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <p className='fw-normal' style={{
                                        color: '#FFF', fontFamily: '"Lexend", sans-serif',
                                        fontSize: '14.9px',
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        lineHeight: '24px',
                                    }}>
                                     Earn Extra USDT with <span className='fw-bold'>18 months</span> stake Plan and get it doubled
                                    </p>
                                </div>
                            </div> */}
                            <div className='d-flex justify-content-start align-items-center pb-3' style={{ gap: '7px' }}>
                                {/* <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#007F60" stroke="#007F60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16.125 9.75L10.6219 15L7.875 12.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div> */}
                                {/* <div>
                                    <p className='fw-normal' style={{
                                        color: '#FFF', fontFamily: '"Lexend", sans-serif',
                                        fontSize: '14.9px',
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        lineHeight: '24px',
                                    }}>All Earning are paid in crypto currency</p>
                                </div> */}
                            </div>
                        </div>

                        {/* <div className='pt-0 pb-3 mt-2 mb-2'>
                            <img src="/assets/level1.png" alt='leve1' className='img-fluid' />
                        </div> */}

                        <div className='px-3'>
                            <div className='text-center'>
                                <img src="/assets/earn-1.png" alt='earn-1' className='img-fluid' style={{ height: 'calc(100vh - 450px)' }} />
                            </div>
                            {/* <div className='d-flex justify-content-start align-items-center pb-4' style={{ gap: '7px' }}>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#007F60" stroke="#007F60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16.125 9.75L10.6219 15L7.875 12.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <p className='fw-normal' style={{
                                        color: '#FFF', fontFamily: '"Lexend", sans-serif',
                                        fontSize: '14.9px',
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        lineHeight: '24px',
                                    }}><span className='fw-bold'>Minimum Investment 500 USDT</span>
                                    </p>
                                </div>
                            </div> */}
                            {/* <div className='d-flex justify-content-start align-items-center pb-4' style={{ gap: '7px' }}>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#007F60" stroke="#007F60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16.125 9.75L10.6219 15L7.875 12.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <p className='fw-normal' style={{
                                        color: '#FFF', fontFamily: '"Lexend", sans-serif',
                                        fontSize: '14.9px',
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        lineHeight: '24px',
                                    }}>YOU WILL GET 100 % Profit After 18 Months Locking Period Along with your Invested Capital</p>
                                </div>
                            </div> */}
                        </div>

                        <div className='plan-footer-1 mt-2 position-absolute bottom-0 w-100' onClick={() => { setPlan(() => "1"); setModalShow(true) }}>
                            <p>{loading ? '...Loading' : 'Choose'}</p>
                        </div>
                    </div>
                </div>
                <div className='width-stake-wrap'>
                    <div className='stake-box position-relative'>
                        <div className='plan-header-1'>
                            <h4 className='text-uppercase' style={{
                                fontSize: '16px',
                                color: '#FFF',
                                fontFamily: '"Lexend", sans-serif',
                                fontStyle: 'normal',
                                fontWeight: 700,
                                lineHeight: 'normal',
                            }}>usdt eARN pLAN 2</h4>
                        </div>

                        <div className='pt-0 pb-2 mt-2 mb-3'>
                            <img src='/assets/investment.png' alt='investment' className='img-fluid' />
                        </div>

                        <div className='px-3'>
                            {/* <div className='d-flex justify-content-start align-items-center pb-3' style={{ gap: '7px' }}>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#007F60" stroke="#007F60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16.125 9.75L10.6219 15L7.875 12.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <p className='fw-normal' style={{
                                        color: '#FFF', fontFamily: '"Lexend", sans-serif',
                                        fontSize: '14.9px',
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        lineHeight: '24px',
                                    }}>
                                        Earn Extra USDT with <span className='fw-bold'>24 months</span> stake Plan and Earn <span className='fw-bold'>3% Monthly</span> Each
                                    </p>
                                </div>
                            </div> */}
                            {/* <div className='d-flex justify-content-start align-items-center pb-3' style={{ gap: '7px' }}>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#007F60" stroke="#007F60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16.125 9.75L10.6219 15L7.875 12.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <p className='fw-normal' style={{
                                        color: '#FFF', fontFamily: '"Lexend", sans-serif',
                                        fontSize: '14.9px',
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        lineHeight: '24px',
                                    }}>All Earning are paid in crypto currency</p>
                                </div>
                            </div> */}
                        </div>

                        {/* <div className='pt-0 pb-3 mt-2 mb-2'>
                            <img src="/assets/level1.png" alt='leve1' className='img-fluid' />
                        </div> */}

                        <div className='px-3'>
                            <div className='text-center'>
                                <img src="/assets/earn-2.png" alt='earn-1' className='img-fluid' style={{ height: 'calc(100vh - 400px)' }} />
                            </div>
                            {/* <div className='d-flex justify-content-start align-items-center pb-4' style={{ gap: '7px' }}>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#007F60" stroke="#007F60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16.125 9.75L10.6219 15L7.875 12.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <p className='fw-normal' style={{
                                        color: '#FFF', fontFamily: '"Lexend", sans-serif',
                                        fontSize: '14.9px',
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        lineHeight: '24px',
                                    }}><span className='fw-bold'>Minimum Investment 500 USDT</span>
                                    </p>
                                </div>
                            </div> */}
                            {/* <div className='d-flex justify-content-start align-items-center pb-4' style={{ gap: '7px' }}>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#007F60" stroke="#007F60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16.125 9.75L10.6219 15L7.875 12.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <p className='fw-normal' style={{
                                        color: '#FFF', fontFamily: '"Lexend", sans-serif',
                                        fontSize: '14.9px',
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        lineHeight: '24px',
                                    }}>YOU WILL GET 3% For 24 Months Earn Along With Capital Return After 24 Months Locking Period</p>
                                </div>
                            </div> */}
                        </div>

                        <div className='plan-footer-1 mt-2 position-absolute bottom-0 w-100' onClick={() => { setPlan(() => "2"); setModalShow(true) }}>
                            <p>{loading ? '...Loading' : 'Choose'}</p>
                        </div>
                    </div>
                </div>

            </div>
            {
                modalShow ? <PlanChoosePopup show={modalShow}
                    onHide={() => {
                        setModalShow(false)
                        setReferralId(null)
                        setPlanAmount1(null)
                    }} plan={plan} planAmount1={planAmount1} setPlanAmount1={setPlanAmount1} setReferralId={setReferralId} referralId={referralId} submitStakeTrade={submitStakeTrade} loading={loading} myProfile={myProfile} /> : null
            }
        </div>
    );
};

export default StakeBox;